/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Asset from './Asset';
var Model = /** @class */ (function (_super) {
    __extends(Model, _super);
    function Model(rawAsset) {
        var _this = _super.call(this, rawAsset) || this;
        _this.isModel = true;
        _this.formats = ['fbx', 'glb'];
        _this.defaultFormat = 'fbx';
        return _this;
    }
    Object.defineProperty(Model.prototype, "model", {
        get: function () {
            return this.findAttachment({
                __typename: 'PreviewAttachment',
                tag: 'model',
                kind: 'model',
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "physicalSizes", {
        /**
         * Get physical size
         * @returns {x:integer,y:integer} values in meters
         */
        get: function () {
            var physicalSize = this.getExtraData('physicalSize');
            if (!physicalSize)
                return null;
            var sizes = physicalSize.split('/');
            return {
                x: parseFloat(sizes[0]),
                y: parseFloat(sizes[1]),
                z: parseFloat(sizes[2]),
            };
        },
        enumerable: false,
        configurable: true
    });
    return Model;
}(Asset));
export default Model;
